// Reading-time helper for blog posts. Uses 225 wpm (industry standard for adult readers).
// Returns both a human-readable label and an ISO 8601 duration for schema.org/BlogPosting.

const WPM = 225;

export function getWordCount(post) {
  if (!post) return 0;
  const content = Array.isArray(post.content) ? post.content.join(" ") : (post.content || "");
  const extras = [post.title, post.excerpt].filter(Boolean).join(" ");
  return (content + " " + extras).trim().split(/\s+/).filter(Boolean).length;
}

export function getReadingMinutes(post) {
  return Math.max(1, Math.round(getWordCount(post) / WPM));
}

export function getReadingLabel(post) {
  const m = getReadingMinutes(post);
  return `${m} min read`;
}

// ISO 8601 duration (e.g., PT5M) for schema.org timeRequired
export function getReadingISO(post) {
  return `PT${getReadingMinutes(post)}M`;
}
